import React from "react";
import {
  Container,
  Paper,
  Typography,
  Box,
  Link,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";

const TermsOfServicePage = () => {
  return (
    <Container maxWidth="md">
      <Paper
        elevation={2}
        sx={{
          mt: { xs: 4, md: 8 },
          mb: { xs: 4, md: 8 },
          p: { xs: 3, md: 6 },
          borderRadius: 3,
        }}
      >
        {/* Header */}
        <Typography variant="h4" fontWeight={700} gutterBottom>
          Terms of Service
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Last Updated: March 2026
        </Typography>

        <Typography variant="body1" sx={{ mb: 3 }}>
          By accessing or using the Capitaland DataForge Application, you agree to
          the following terms and conditions.
        </Typography>

        <Divider sx={{ my: 3 }} />

        {/* Section 1 */}
        <Typography variant="h6" fontWeight={600} gutterBottom>
          User Responsibilities
        </Typography>

        <List dense>
          {[
            "Use the application only for lawful purposes",
            "Not attempt unauthorized access to systems or data",
            "Maintain confidentiality of login credentials",
          ].map((item) => (
            <ListItem key={item}>
              <ListItemText primary={item} />
            </ListItem>
          ))}
        </List>

        <Divider sx={{ my: 3 }} />

        {/* Section 2 */}
        <Typography variant="h6" fontWeight={600} gutterBottom>
          Account Suspension
        </Typography>

        <Typography variant="body1">
          BImage Consulting reserves the right to suspend or terminate accounts
          that violate these terms or engage in activities that compromise
          system security or integrity.
        </Typography>

        <Divider sx={{ my: 3 }} />

        {/* Section 3 */}
        <Typography variant="h6" fontWeight={600} gutterBottom>
          Third-Party Services
        </Typography>

        <Typography variant="body1">
          We are not responsible for data loss, service interruptions, or
          security issues resulting from third-party services such as Google
          Drive or Autodesk Construction Cloud.
        </Typography>

        <Divider sx={{ my: 3 }} />

        {/* Section 4 */}
        <Typography variant="h6" fontWeight={600} gutterBottom>
          Contact Information
        </Typography>

        <Typography variant="body1">
          For inquiries regarding these Terms of Service, please contact:
        </Typography>

        <Box sx={{ mt: 1 }}>
          <Link href="mailto:support@bimageconsulting.com" underline="hover">
            support@bimageconsulting.com
          </Link>
        </Box>
      </Paper>
    </Container>
  );
};

export default TermsOfServicePage;